<micro-select-combo #sel
              placeholder="DB2SMS Status"
              [mode]="mode"
              [(id)]="status"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched"
>
</micro-select-combo>
